import {classify} from './analysis';
import {sixPrediction} from './sixPrediction';
export const SIX_WINDOW=100;
const RED=new Set([1,2,7,8,12,13,18,19,23,24,29,30,34,35,40,45,46]);
const BLUE=new Set([3,4,9,10,14,15,20,25,26,31,36,37,41,42,47,48]);
export const sixWave=n=>RED.has(n)?'红波':BLUE.has(n)?'蓝波':'绿波';
export const sixValue=(draw,play)=>play==='wave'?sixWave(draw.numbers[6]):classify(draw,'six',play);
export const SIX_CATEGORIES=[['size','大小',['大','小','和']],['parity','单双',['单','双','和']],['wave','色波',['红波','蓝波','绿波']],['family','家禽 / 野兽',['家','野']]];
export function sixCategoryStats(history) {
 const sample=history.slice(0,SIX_WINDOW);
 return SIX_CATEGORIES.map(([id,label,choices])=>({id,label,rows:choices.map(value=>{
  const values=sample.map(d=>sixValue(d,id)),index=values.indexOf(value);
  return {value,count:values.filter(v=>v===value).length,missing:index<0?sample.length:index};
 })}));
}
export function sixRoad(history,play) {
 let col=-1,row=0,previous;
 const draws=history.slice(0,SIX_WINDOW).reverse();
 return draws.map((draw,i)=>{
  const value=sixValue(draw,play),gap=i>0&&Number(draw.issue)-Number(draws[i-1].issue)!==1;
  if(i===0||gap||value!==previous){col+=gap?2:1;row=0;}else row++;
  previous=value;return {issue:draw.issue,value,col,row};
 });
}
export function sixPageBacktest(history,play) {
 const sample=history.slice(0,SIX_WINDOW);
 return sample.slice(0,-1).flatMap((draw,i)=>{
  if(Number(draw.issue)-Number(sample[i+1].issue)!==1) return [];
  const predicted=sixPrediction(sample.slice(i+1)).fields.find(f=>f.id===play).value;
  const actual=sixValue(draw,play);
  return [{issue:draw.issue,number:draw.numbers[6],predicted,actual,hit:!actual||actual==='和'?null:predicted===actual}];
 });
}
